import { render, staticRenderFns } from "./BaseOptionGroup.vue?vue&type=template&id=66e4b0b8"
import script from "./BaseOptionGroup.vue?vue&type=script&lang=js"
export * from "./BaseOptionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports